(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/components/params.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/components/params.js');

'use strict';

const {
  useAtomValue,
  useSetAtom
} = jotai;
const {
  useHomeLocation,
  useHomeLocationSelfService,
  useGeolocation
} = svs.lyckoplatsen.components.page_play.react.hooks;
const {
  shouldAutoPayAtom,
  shouldPayAfterDepositAtom,
  isGameValidAtom
} = svs.lyckoplatsen.components.page_play.jotai.atoms;
const {
  isSelfService
} = svs.core.config.data.svsconfig;
const Params = () => {
  const {
    ParamHandler
  } = svs.lyckoplatsen.react;
  const setShouldAutoPay = useSetAtom(shouldAutoPayAtom);
  const setShouldPayAfterDeposit = useSetAtom(shouldPayAfterDepositAtom);
  const isGameValid = useAtomValue(isGameValidAtom);
  const handleHomeLocation = useHomeLocation();
  const handleHomeLocationSelfService = useHomeLocationSelfService();
  const handleGeoLocation = useGeolocation();
  const params = [{
    key: 'locationHome',
    action: isSelfService ? handleHomeLocationSelfService : handleHomeLocation
  }, {
    key: 'pay',
    action: () => {
      setShouldAutoPay(true);
    }
  }, {
    key: 'locationType',
    action: type => {
      var _home$current$type, _home$current;
      return (_home$current$type = (_home$current = {
        home: isSelfService ? handleHomeLocationSelfService : handleHomeLocation,
        current: handleGeoLocation
      })[type]) === null || _home$current$type === void 0 ? void 0 : _home$current$type.call(_home$current);
    }
  }, {
    key: 'afterpay',
    action: () => {
      if (svs.core.detect.feature('ft-lyckoplatsen-pay-after-deposit')) {
        setShouldPayAfterDeposit(isGameValid);
      }
    }
  }];
  return React.createElement(ParamHandler, {
    params: params
  });
};
setGlobal('svs.lyckoplatsen.components.page_play.react.components', {
  Params
});

 })(window);